export const createLogger = () => {
  let debugMode = false
  return {
    log: (...params: Parameters<typeof console.log>) => {
      if (debugMode) {
        // eslint-disable-next-line no-console
        console.log(...params)
      }
    },
    error: (...params: Parameters<typeof console.error>) => {
      if (debugMode) {
        // eslint-disable-next-line no-console
        console.error(...params)
      }
    },
    warn: (...params: Parameters<typeof console.warn>) => {
      if (debugMode) {
        // eslint-disable-next-line no-console
        console.warn(...params)
      }
    },
    info: (...params: Parameters<typeof console.info>) => {
      if (debugMode) {
        // eslint-disable-next-line no-console
        console.info(...params)
      }
    },
    setDebugMode: (debug: boolean) => {
      debugMode = debug
    },
    getDebugMode: () => {
      return debugMode
    },
  }
}
